import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { LoadingConfig } from './loading-content.component'

export { LoadingConfig } from './loading-content.component'

@Component({
  selector: '[lemon-loading]',
  template: `
    @if (show) {
      <div lemon-loading-content [config]="config"></div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingComponent {
  @Input() show: boolean
  @Input() config: LoadingConfig = {
    fullScreenBackdrop: false,
    backdropBackgroundColour: 'rgba(255,255,255,0)',
    backdropBorderRadius: '4px',
    primaryColour: 'rgba(0, 0, 0, 0.15)',
    secondaryColour: 'rgba(0, 0, 0, 0.15)',
    tertiaryColour: 'rgba(0, 0, 0, .15)',
  }
}
